import moment from "moment";

export const automaticDraws = (data, tnh, time) => {
  //   Get Confirm Players
  let filterConfirmPlayers = data?.players?.filter(
    (val) => val.tournament_status === "confirmed"
  );

  //   Sort Players according to lowest Ranking
  let potyRankSort = filterConfirmPlayers.sort(
    (a, b) => b.poty_rank - a.poty_rank
  );

  //   For Creating Dynamic Draws
  let noOfDraws = Math.ceil(filterConfirmPlayers.length / 4);
  let tempArr = new Array(noOfDraws).fill({});

  let finalOutput = [];
  let index = 0;
  let drawPlayerLoopCount = 4;

  // Check if Last draw has 3 players
  if (filterConfirmPlayers.length % 4 === 3) {
    drawPlayerLoopCount = 3;
  }
  //   Creating draws according to number of players
  for (let i = 0; i < tempArr.length; i++) {
    let tempPlayersArr = [];
    //   Set Tee Time
    let teeOffTime = time;

    let courseName =
      data?.teeOffsFrom.toLowerCase() === "both sides"
        ? (i + 1) % 2
          ? tnh?.back_9
          : tnh?.front_9
        : data.teeOffsFrom;

    let tempDrawObj = {};

    if (data?.teeOffsFrom.toLowerCase() === "both sides") {
      if (i >= 2) {
        for (let j = 2; j <= i; j += 2) {
          teeOffTime = moment(teeOffTime).add(
            data.timeBetweenFlights,
            "minute"
          );
        }

        tempDrawObj = {
          draw_index: i,
          group_name: `group ${i + 1}`,
          dateTime: teeOffTime.toISOString(true),
          course_name: courseName,
          draw_players: [],
          time: teeOffTime.format("LT"),
          timeObj: teeOffTime,
        };
      } else {
        tempDrawObj = {
          draw_index: i,
          dateTime: teeOffTime,
          group_name: `group ${i + 1}`,
          course_name: courseName,
          draw_players: [],
          time: moment(teeOffTime).format("LT"),
          timeObj: teeOffTime,
        };
      }
    } else {
      for (let j = 1; j <= i; j++) {
        teeOffTime = moment(teeOffTime).add(data.timeBetweenFlights, "minute");
      }

      tempDrawObj = {
        draw_index: i,
        dateTime: teeOffTime.toISOString(true),
        group_name: `group ${i + 1}`,
        course_name: courseName,
        draw_players: [],
        time: moment(teeOffTime).format("LT"),
        timeObj: teeOffTime,
      };
    }

    // Adding player to draw
    for (let j = 0; j < drawPlayerLoopCount; j++) {
      if (potyRankSort[index] !== undefined) {
        let tempDrawPlayer = {
          ...potyRankSort[index],
        };
        tempPlayersArr.push(tempDrawPlayer);
        index++;
      }
    }

    tempDrawObj["draw_players"] = tempPlayersArr;
    finalOutput.push(tempDrawObj);

    drawPlayerLoopCount = 4;
  }

  //   Final Automatic Draws Object
  let finalObj = {
    ...data,
    draws: finalOutput,
  };

  return finalObj;
};
